var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15.2754H7.5C5.4375 15.2754 3.75 13.5879 3.75 11.5254V7.77539C3.75 5.71289 5.4375 4.02539 7.5 4.02539H13.125C15.1875 4.02539 16.875 5.71289 16.875 7.77539V11.5254C16.875 13.5879 15.1875 15.2754 13.125 15.2754ZM39 13.4004H32.25C31.0125 13.4004 30 12.3879 30 11.1504V8.15039C30 6.91289 31.0125 5.90039 32.25 5.90039H39C40.2375 5.90039 41.25 6.91289 41.25 8.15039V11.1504C41.25 12.3879 40.2375 13.4004 39 13.4004ZM39 27.4629H32.25C31.0125 27.4629 30 26.4504 30 25.2129V22.2129C30 20.9754 31.0125 19.9629 32.25 19.9629H39C40.2375 19.9629 41.25 20.9754 41.25 22.2129V25.2129C41.25 26.4504 40.2375 27.4629 39 27.4629Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 9.65039H30",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 9.65039V34.0254C23.4375 36.0879 25.125 37.7754 27.1875 37.7754H30M23.4375 23.7129H30",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41.5254H32.25C31.0125 41.5254 30 40.5129 30 39.2754V36.2754C30 35.0379 31.0125 34.0254 32.25 34.0254H39C40.2375 34.0254 41.25 35.0379 41.25 36.2754V39.2754C41.25 40.5129 40.2375 41.5254 39 41.5254Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCollection);
export default __webpack_public_path__ + "static/media/data_collection.147e0276408e2c94f24d919671189bf2.svg";
export { ForwardRef as ReactComponent };